export function customChartData() {
  return {
    chart: {
      title: false,
      spacingTop: 25,
      height: 260,
      backgroundColor: 'transparent'
    },
    tooltip: {
      valueDecimals: 2
    },
    colors: ['#66CBE0', '#FFFFFF'],
    plotOptions: {
      line: {
        lineWidth: 0
      }
    },
    yAxis: {
      tickAmount: 5,
      labels: {
        style: {
          color: 'white'
        }
      },
      gridLineColor: '#9A9FAE'
    },
    xAxis: {
      labels: {
        rotation: 0,
        style: {
          color: 'white'
        }
      }
    }
  }
}
